export default "__VITE_ASSET__be3bc0ea__"